import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import { createCookieStorage } from '../../../helper/cookieStorage'
import { selectColorTheme } from '../../../redux/selector/system'

const colorThemeStorage = createCookieStorage({ name: 'colorTheme', path: '/' })

const readColorTheme = () => {
	const stored = colorThemeStorage.get()
	return stored === 'DARK' || stored === 'LIGHT' ? stored : 'LIGHT'
}

const AppThemeProvider = React.memo(({ children }) => {
	const shellColorTheme = useSelector(selectColorTheme)
	const [storedColorTheme] = useState(readColorTheme)
	const colorTheme = shellColorTheme || storedColorTheme

	return <ThemeProvider theme={{ colorTheme }}>{children}</ThemeProvider>
})

AppThemeProvider.displayName = 'AppThemeProvider'
export default AppThemeProvider
